// extracted by mini-css-extract-plugin
module.exports = {"CategoryItems":"CategoryItems_CategoryItems__329aM","LoaderWrapper":"CategoryItems_LoaderWrapper__TQDIZ","Title":"CategoryItems_Title__1fFdf"};